var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84804 4.28125L0 7.67411V1.42857C0 0.640625 0.597956 0 1.33342 0H3.7815C4.13569 0 4.47529 0.149554 4.72531 0.417411L5.27743 1.00893C5.52744 1.27679 5.86705 1.42634 6.22124 1.42634H8.66723C9.40269 1.42634 10.0006 2.06696 10.0006 2.85491V3.5692H3.00019C2.52516 3.5692 2.08764 3.83929 1.84804 4.27902V4.28125ZM2.42307 4.64062C2.54392 4.41964 2.76268 4.28571 3.00019 4.28571H11.3341C11.5737 4.28571 11.7924 4.42188 11.9112 4.64509C12.0299 4.8683 12.0299 5.14063 11.9091 5.36161L9.57562 9.64732C9.45686 9.86607 9.2381 10 9.00058 10H0.66671C0.427111 10 0.208347 9.86384 0.0895892 9.64062C-0.0291686 9.41741 -0.0291686 9.14509 0.0916726 8.92411L2.42516 4.63839L2.42307 4.64062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorLogo);
export default __webpack_public_path__ + "static/media/vector-logo.201b1ce0a58c6ec99497654ec8dc3321.svg";
export { ForwardRef as ReactComponent };